import {SketchPicker} from "react-color";
import {useState} from "react";

const PickColor = ({label, color , onChange} ) => {
    const [tempColor , setTempColor] = useState(color || "#ff0000" );

    return (
        <div className="card">
            <div className="card-body">
                {label && <label className="card-title mb-2 d-block">{label}</label>}
                <SketchPicker
                    width={'100%'}
                    color={tempColor}
                    onChange = {(color) => {setTempColor(color.hex)} }
                    onChangeComplete={ (color) => {onChange(color.hex)} }
                />
            </div>
        </div>
    );
}

export const PickColorWithoutContainer = ({label, color , onChange} ) => {
    const [tempColor , setTempColor] = useState(color || "#ff0000" );

    return (
        <div>
            {label && <label className="card-title mb-2 d-block">{label}</label>}
            <SketchPicker
                width={'100%'}
                color={tempColor}
                onChange = {(color) => {setTempColor(color.hex)} }
                onChangeComplete={ (color) => {onChange(color.hex)} }
            />
        </div>
    );
}

export default PickColor;